<template>
  <div class="product-card">
    <img :src="product.image" alt="">
    <h2>{{product.title}}</h2>
    <p>{{ product.description.length > 150 ? product.description.slice(0, 150) + "..." : product.description }}</p>
    <div class="buttons">
      <app-btn
          @click="clickedBuy"
          v-if="!product.buyed"
      >
        Buy for {{product.regular_price}} £
      </app-btn>
      <app-btn
          @click="clickedRead"
          v-else
      >
        {{goText}}
      </app-btn>
      <app-btn styling="inline" @click="onSelectLearn">Learn more ></app-btn>
    </div>
  </div>
</template>

<script>
import HeadedContainer from "@/components/common/HeadedContainer";
export default {
  components: {
    HeadedContainer
  },
  props: ['product'],
  methods: {
    onSelectLearn() {
      this.$router.push(`/dashboard/market/${this.product.type}/${this.product.id}/info`);
    },
    clickedRead() {
      this.$router.push(`/dashboard/market/${this.product.type}/${this.product.id}`);
    },
    clickedBuy() {
      this.$store.commit('market/buyProduct', this.product.id);
    }
  },
  computed: {
    goText() {
      return this.product.type === 'book' ? 'Read' : 'Watch';
    }
  }
}
</script>

<style lang="scss">
.product-card {
  margin-right: 46px;
  max-width: 100%;
  width: 330px;
  background-color: #fff;
  border-radius: 5px;
  padding: 20px 10px;
  margin-bottom: 46px;
  display: flex;
  flex-direction: column;
  .buttons {
    display: flex;
    margin-top: auto;
  }
  img {
    width: 100%;
  }
}
</style>